import { useEffect, useState } from "react";
import { initGA, CONSENT_KEY as KEY } from "./analytics";

// Consent state: shows the banner until a choice is stored; `delayUntilScroll` (Design Studio) waits for the first scroll.
export function useCookieConsent(delayUntilScroll) {
  const [pending, setPending] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(KEY);
    if (choice === "accepted") initGA();
    if (!choice) setPending(true);
  }, []);

  useEffect(() => {
    if (!delayUntilScroll || !pending || scrolled) return;
    const onScroll = () => { if (window.scrollY > 40) setScrolled(true); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [delayUntilScroll, pending, scrolled]);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    if (choice === "accepted") initGA();
    setPending(false);
  };

  return { visible: pending && (!delayUntilScroll || scrolled), decide };
}
